import type React from 'react';

import type { ColorTag } from '@shared/types/common';
import type { Client } from '@shared/types/users';

import * as st from './styles.module.scss';

type Props = {
	client: Client | undefined;
	selectedColorTag?: ColorTag | null;
};

export const Color: React.FC<Props> = ({ client, selectedColorTag }) => {
	// const { client } = useClient(id);

	return (
		<div
			className={st.client__color}
			style={{
				display:
					selectedColorTag?.color !== undefined || client?.color_tag !== null ? 'grid' : 'hidden',
				backgroundColor: `${
					selectedColorTag?.color !== undefined
						? selectedColorTag?.color
						: client?.color_tag !== null
						? client?.color_tag
						: 'none'
				}`,
			}}
		/>
	);
};
